import { useEffect, useMemo, useRef, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { initPaykassmaDeposit, initPaykassmaWithdrawal } from 'features/payment/redux/actions';
import getTokenData from 'shared/helpers/getTokenData';

const usePaymentFrame = ({ type, amount, phone }) => {
  const dispatch = useDispatch();

  const auth = useSelector(state => state.auth);
  const { paymentLink, actionProcessing, isPaymentReady } = useSelector(state => state.payment);

  const [isInitReady, setIsInitReady] = useState(false);

  const containerRef = useRef(null);
  const hasRequested = useRef(false);

  const onMessageReceived = (event) => {
    try {
      const data = JSON.parse(event.data);
      if (data?.eventType === 'payment_status') {
        const { status } = data;
        window.location.href = `/payment-result?status=${status}`;
      }
    } catch (err) {
      console.error('Invalid postMessage data:', err);
    }
  };
  

  useEffect(() => {
    const tokenData = getTokenData(auth);
    window.addEventListener('message', onMessageReceived, false);

    if (!paymentLink && tokenData && amount && !hasRequested.current) {
      hasRequested.current = true;
      setIsInitReady(true);
      if (type === 'deposit') {
        dispatch(initPaykassmaDeposit({ amount }));
      } 
    /*   else if (type === 'withdrawal' && phone) {
        dispatch(initPaykassmaWithdrawal({ amount, phoneNumber: phone }));
      } */
    }
    return () => window.removeEventListener('message', onMessageReceived);
  }, [dispatch, auth, type, amount, phone, paymentLink]);

  return useMemo(
    () => ({
      containerRef,
      isInitReady,
      paymentLink,
      isPaymentLoading: actionProcessing,
      isPaymentReady,
    }),
    [isInitReady, paymentLink, isPaymentReady, actionProcessing],
  );
};

export default usePaymentFrame;
